<template>
  <template v-if="switchData.switch_url">
    <template v-if="hasDynamicLabels">
      <div class="flex justify-center">
        <div
          class="flex w-full items-center gap-1 whitespace-nowrap rounded-md border border-gray-200 p-0.5 shadow-sm"
        >
          <template v-for="label in ['label1', 'label2']" :key="label">
            <a
              v-if="switchData.switch_option.selected_label !== label"
              :href="switchData.switch_url"
              class="w-full rounded-md bg-transparent p-2 text-center transition-all duration-200 ease-in-out hover:bg-primary hover:font-bold hover:text-white"
            >
              {{ getSwitchOptionValue(label) }}
            </a>

            <span
              v-else
              class="w-full rounded-md bg-primary p-2 text-center font-bold text-white"
            >
              {{ getSwitchOptionValue(label) }}
            </span>
          </template>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="flex justify-center">
        <div class="flex flex-row items-center gap-3 whitespace-nowrap">
          <template v-if="isCollection">
            <a
              :href="switchData.switch_url"
              class="flex-1 rounded-full bg-[#117a65] px-6 py-2 font-bold text-white"
            >
              {{ $t('pages.product_detail_page.switch_options.with_name') }}
            </a>
            <span
              class="flex-1 rounded-full bg-primary px-6 py-2 font-bold text-white"
            >
              {{ $t('pages.product_detail_page.switch_options.without_name') }}
            </span>
          </template>

          <template v-else>
            <span
              class="flex-1 rounded-full bg-primary px-6 py-2 font-bold text-white"
            >
              {{ $t('pages.product_detail_page.switch_options.with_name') }}
            </span>
            <a
              :href="switchData.switch_url"
              class="flex-1 rounded-full bg-[#117a65] px-6 py-2 font-bold text-white"
            >
              {{ $t('pages.product_detail_page.switch_options.without_name') }}
            </a>
          </template>
        </div>
      </div>
    </template>
  </template>
</template>

<script setup lang="ts">
import { computed, type ComputedRef } from 'vue';
import type { SwitchDataType } from '@/types/SwitchDataType.ts';

defineProps({
  isCollection: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const switchData: ComputedRef<SwitchDataType> = computed(
  () => window.switch_data
);
const hasDynamicLabels: ComputedRef<boolean> = computed(() => {
  return (
    !!switchData.value.switch_option.label1 &&
    !!switchData.value.switch_option.label2
  );
});

function getSwitchOptionValue(label: string): string {
  return (
    switchData.value.switch_option[
      label as keyof typeof switchData.value.switch_option
    ] ?? ''
  );
}
</script>
